<template>
  <div class="top-bar-components"
       :class="{
         'header-fixed': isFixed && showHeader,
         'header-hide-fixed': isFixed && !showHeader,
       }"
  >
    <agency-setting-bar v-if="showAgencySettingBar"
                        :info="agencySettingBar"
    />
    <!-- 下载app小标题注释 -->
    <!-- <down-load-guide-bar v-else
                         class="guide-bar"
                         :class="{ 'header-fixed': isFixed }"
                         :hide-bar="!isMobileWeb"
    /> -->
    <slot name="header">
      <ym-header v-if="showHeader"
                 :fixed="isMobileWeb && isFixed"
                 :show-back="isMobileWeb && showBack"
                 :plain="headerPlain"
                 :back-color="backColor"
      >
        {{ title }}
        <template #right>
          <div>
            <slot name="header-right"></slot>
          </div>
        </template>
      </ym-header>
    </slot>
  </div>
</template>

<script>
  import { Header } from '@ymba/ym-ui';
  import { mapActions, mapGetters } from 'vuex';
  import DownLoadGuideBar from '@/components/DownLoadGuideBar';
  import AgencySettingBar from '@/components/AgencySettingBar';
  import { isMobileWeb } from '@/utils';

  export default {
    name: 'TopBar',
    components: {
      AgencySettingBar,
      DownLoadGuideBar,
      'ym-header': Header,
    },
    data() {
      return {
        isMobileWeb: isMobileWeb(),
        isFixed: false,
        hideDownLoadBar: false,
      };
    },
    props: {
      showHeader: Boolean,
      title: String,
      fixed: {
        type: Boolean,
        default: true,
      },
      showBack: {
        type: Boolean,
        default: true,
      },
      headerPlain: Boolean,
      backColor: String,
    },
    computed: {
      ...mapGetters([
        'agencySettingBar',
      ]),
      showAgencySettingBar() {
        return this.agencySettingBar.show;
      },
    },
    methods: {
      ...mapActions([
        'toggleScrollToHideDownloadBar',
      ]),
      handleScroll(e) {
        const { fixed } = this;
        if (!fixed) return;
        const scrollY = document.documentElement.scrollTop || document.body.scrollTop || 0;
        const isFixed = scrollY > 0 || e.target.scrollTop > 0;
        this.isFixed = isFixed;
        this.toggleScrollToHideDownloadBar(isFixed);
      },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll, true);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .top-bar-components {
    &.header-fixed {
      height: 80px;
    }
    &.header-hide-fixed {
      height: 0;
    }

    .ym-header {
      &.is-plain {
        &::after {
          content: none;
        }
      }
    }
  }

  .guide-bar {
    &.header-fixed {
      visibility: hidden;
    }
  }
</style>
